import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/config/routes.config';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageEnums } from 'src/shared/models/enums';
import { MenuItems } from 'src/shared/models/global.model';


@Injectable({
	providedIn: 'root'
})
export class MenuHelperService {
	items: Array<MenuItems> = [];

	constructor(private storage: StorageService) {
	}

	async getItems(isAuth: boolean): Promise<MenuItems[]> {
		const isUserLogged = true;
		const showMarketplace = await this.storage.getItem(StorageEnums.SHOW_MARKETPLACE);
		isAuth = isAuth && isUserLogged === true;
		this.items = [];
		const routes = AppConfig.routes;
		if(isAuth) {
			this.items.push({
				icon: 'home',
				title: 'menu.home',
				url: routes.home.fullPath
			});
		}
		// if (isAuth) {
		// 	this.items.push({
		// 		icon: 'stopwatch',
		// 		title: 'users.my-free-hours',
		// 		url: routes.profile.myFreeHours.fullPath
		// 	});
		// }
		// if(isAuth && showMarketplace) {
		// 	this.items.push({
		// 		icon: 'marketplace',
		// 		title: 'menu.marketplace',
		// 		url: routes.marketplace.fullPath
		// 	});
		// }
		// if (isAuth) {
		// 	if(showMarketplace) {
		// 		this.items.push({
		// 			icon: 'shopping-bag',
		// 			title: 'menu.purchases',
		// 			url: routes.purchases.fullPath
		// 		});
		// 	}
		// 	this.items.push({
		// 		icon: 'payment-history',
		// 		title: 'menu.payment-history',
		// 		url: routes.payments.paymentHistory.fullPath
		// 	});
		if(isAuth) {
			this.items.push({
				icon: 'profile',
				title: 'menu.my-account',
				url: routes.account.fullPath
			});
		}
		if(isAuth) {
			this.items.push({
				icon: 'help',
				title: 'menu.profile',
				url: routes.settings.fullPath
			});
		}
		if(isAuth) {
			this.items.push({
				icon: 'support-menu',
				title: 'menu.help',
				url: routes.support.fullPath
			});}

		// 	if(isAuth && showMarketplace) {
		// 		this.items.push({
		// 			icon: 'contact-us',
		// 			title: 'menu.chat',
		// 			url: routes.chat.fullPath
		// 		});
		// 	}
		// }

		// this.items.push({
		// 	icon: 'support-menu',
		// 	title: 'menu.help',
		// 	url: '',
		// 	submenu: []
		// });

		// const submenu = this.items.find(v => v.icon === 'support-menu');

		// submenu.submenu.push({
		// 	icon: 'user-guide',
		// 	title: 'menu.user-guide',
		// 	url: routes.info.userGuide.fullPath
		// });
		// submenu.submenu.push({
		// 	icon: 'faq',
		// 	title: 'menu.faq',
		// 	url: routes.info.faq.fullPath
		// });
		// if (isAuth) {
		// 	submenu.submenu.push({
		// 		icon: 'support',
		// 		title: 'claims.title',
		// 		isBeta: true,
		// 		url: routes.claims.fullPath
		// 	});
		// }
		// submenu.submenu.push({
		// 	icon: 'contact-us-new',
		// 	title: 'menu.contact-us',
		// 	url: routes.info.contactUs.fullPath
		// });

		// this.items.push({
		// 	icon: 'about',
		// 	title: 'menu.about-this-app',
		// 	url: routes.info.about.fullPath
		// });
		if (isAuth) {
			this.items.push({
				icon: 'app-logout',
				title: 'sidebar.logout',
				url: routes.auth.signIn.fullPath
			});
		} else {
			this.items.push({
				icon: 'login',
				title: 'buttons.sign-in',
				url: routes.auth.signIn.fullPath
			});
		}
		return this.items;
	}

	getFooterItems(isAuth: boolean) {
		if (isAuth) {
			const routes = AppConfig.routes;
			const items = [
				{
					icon: '/home',
					title: 'sidebar.my-booking',
					url: routes.home.fullPath
				},
				{
					icon: '/facilities/map',
					title: 'buttons.find-v-locker',
					url: routes.facilities.map.fullPath
				},
				{
					icon: 'help',
					title: 'menu.profile',
					url: routes.profile.fullPath
				}
			];

			return items;
		}
	}
}
